// import { configureStore } from "@reduxjs/toolkit";
// import authReducer from "./authslice";
// import CartReducer from "./cartslice";
// import { apiSlice } from "./apislice";
// import categoriesslice from "./categoriesslice";
// import OthersSlice from "./otherslice";

// export const Store = configureStore({
//   reducer: {
//     [apiSlice.reducerPath]: apiSlice.reducer,
//     auth: authReducer,
//     Cart: CartReducer,
//     Category: categoriesslice,
//     others: OthersSlice,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware()
//       .concat(apiSlice.middleware)
// });



import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./authslice";
import CartReducer from "./cartslice";
import { apiSlice } from "./apislice";
import categoriesslice from "./categoriesslice";
import OthersSlice from "./otherslice";

const appReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  Cart: CartReducer,
  Category: categoriesslice,
  others: OthersSlice,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/clearCredentials') {
    state = undefined;
  }
  return appReducer(state, action);
};



export const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(apiSlice.middleware),
  devTools: {
    trace: false,
    traceLimit: 25,
  },
});

